import { MultiValuedListMoreItem } from '../../MultiValuedList'
import { EntityMultiValue } from '../EntityMultiValue'

import * as styles from './EntityMultiValuedListMoreItem.module.css'

function EntityMultiValuedListMoreItem({
  Icon,
  children,
  className = styles.EntityMultiValuedListMoreItem,
  description,
  iconSize,
  ref,
  src,
  unread,
  valueProps,
  ...itemProps
}) {
  const valueItemProps = {
    ...valueProps,
    Icon,
    children,
    description,
    iconSize,
    src,
    unread,
  }

  return (
    <MultiValuedListMoreItem {...itemProps} className={className} ref={ref}>
      <EntityMultiValue {...valueItemProps} />
    </MultiValuedListMoreItem>
  )
}

export default EntityMultiValuedListMoreItem
